import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IUpdateUserStartPageParams {
  userId?: string;
  startPage: string;
}

export class UpdateUserStartPageRequest extends Request<IUpdateUserStartPageParams, IResult> {
  constructor(params: IUpdateUserStartPageParams) {
    super('updateUserStartPage', params);
  }
}
